//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('invoiceMakeOverview', {
//        templateUrl: 'views/components/views/invoiceMakeOverview/invoiceMakeOverview.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'rememberService', 'logisticService', 'invoiceMakeOverviewService', function (stateService, utilityService, rememberService, logisticService, invoiceMakeOverviewService) {
//            const vm = this;
    		
//            let variableNames = {
//                businessco_no: ''
//            };

//            vm.model = {
//                setting: {},
//                selectListCompanies: [],
//                itemsListOverviews: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await invoiceMakeOverviewService.getInvoiceMakeOverviews())[0];
//            };

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }
            
//            async function loadInvoiceMakeOverviews() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;
                
//                return vm.model.itemsListOverviews = await invoiceMakeOverviewService.listInvoiceMakeOverviews(vm.model.setting);
//            }
            
//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });
                
//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;
                
//                let variableValue = null;
                
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;
                        
//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }
                
//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

//                        rememberFunc('businessco_no');
//                        loadInvoiceMakeOverviews();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };
            
//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();
//                loadInvoiceMakeOverviews();
//            }
//        }]
//    });
//})();
